import { MatSnackBar } from '@angular/material/snack-bar';
import { TravelAdvisorProfileServiceFactory } from './../travel-advisor-profile.service';
import { User, Role } from "./../user.model";
import { AuthService } from "./../auth.service";
import { TravelAdvisorProfile } from "./../travel-advisor-profile.model";
import { Component, OnInit, Input } from "@angular/core";
import { TravelAdvisorProfileService } from "../travel-advisor-profile.service";
import { first } from 'rxjs/operators';

@Component({
  selector: "app-ta-profile-form",
  templateUrl: "./ta-profile-form.component.html",
  styleUrls: ["./ta-profile-form.component.css"]
})
export class TaProfileFormComponent implements OnInit {
  constructor(
    private profileServiceFactory: TravelAdvisorProfileServiceFactory,
    private authService: AuthService,
    private snackBar: MatSnackBar,
  ) { }

  @Input()
  user: User;

  profileService: TravelAdvisorProfileService;
  profile: TravelAdvisorProfile;
  private isNew = false;
  oldHandle: string;

  async ngOnInit() {
    this.profileService = this.profileServiceFactory.create(this.user.id);

    this.profile = await this.profileService.get("default").pipe(first()).toPromise();
    if (!this.profile.id) {
      this.profile = new TravelAdvisorProfile({ id: "default" });
      this.isNew = true;
    }
    this.oldHandle = this.profile.handle;
  }

  isAdmin() {
    return this.authService.user && this.authService.user.hasRole(Role.ADMIN);
  }

  save() {

    if (!this.isNew && this.oldHandle != this.profile.handle) {
      if (!confirm("Vuoi veramente cambiare l'id da " + this.oldHandle + " a " + this.profile.handle + "? Questa è un'operazione molto delicata...")) {
        return;
      }
    }

    (this.isNew ? this.profileService
      .create(this.profile) : this.profileService
        .update(this.profile))

      .then(() => {
        this.isNew = false;
        this.oldHandle = this.profile.handle;
        this.snackBar.open("Profilo salvato 😉", null, {
          duration: 1000
        });
      })
      .catch((e) => {
        console.error(e);
        this.snackBar
          .open("Errore durante il salvataggio del profilo 😢", "Riprova", {
            duration: 4000
          })
          .onAction()
          .subscribe(() => {
            this.save();
          });
      });
  }

}
